import { useMemo } from 'react';
import { shallowEqual, useLocation, useSelector } from 'umi';
import { extractDashboardGameCodeFromPath } from '../utils/gameSelectOption';

/**
 * 读取经分页面当前 gameCode：redux currentGame 优先，URL pathname 兜底。
 */
const useDashboardRouteGameCode = (): string => {
  const location = useLocation();
  const dashboardCurrentGameCode = useSelector(
    (state: any) => state.dashboard?.currentGame?.game_code as string | undefined,
    shallowEqual,
  );

  return useMemo(() => {
    const routeGameCode = extractDashboardGameCodeFromPath(location.pathname);
    return dashboardCurrentGameCode || routeGameCode || '';
  }, [location.pathname, dashboardCurrentGameCode]);
};

export default useDashboardRouteGameCode;
